export default {
  'app.settings.open': '開',
  'app.settings.close': '關',
  'unit.primary_name': '主要名稱',
  'unit.secondary_name': '次要名稱',
  'unit.name': '名稱',
  'role.name': '名稱',
  'role.permissions': '權限',
};
